let ReactPixel = null;

const options = {
  autoConfig: true,
  debug: false,
};

export const initFacebookPixel = async pixelId => {
  if (typeof window !== 'undefined' && pixelId) {
    if (!ReactPixel) {
      const module = await import('react-facebook-pixel');
      ReactPixel = module.default;
    }

    ReactPixel.init(pixelId, {}, options);
    ReactPixel.pageView();
  }
};

export const trackFacebookEvent = async (eventName, data = {}, eventID) => {
  if (typeof window !== 'undefined') {
    if (!ReactPixel) {
      const module = await import('react-facebook-pixel');
      ReactPixel = module.default;
    }

    // eventID enables browser<->CAPI server-side dedup (Meta matches on it).
    if (eventID) {
      ReactPixel.track(eventName, data, { eventID });
    } else {
      ReactPixel.track(eventName, data);
    }
  }
};

// Read the Meta browser cookies so the server-side CAPI event can match the
// same user (improves match quality + dedup). Safe no-op on the server.
export const getFbCookies = () => {
  if (typeof document === 'undefined') return { fbp: null, fbc: null };
  const read = name => {
    const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  };
  let fbc = read('_fbc');
  // If this visit has a fresh Meta click id, prefer a freshly-built _fbc so we
  // don't misattribute to a stale prior click (Meta match-quality best practice).
  try {
    if (typeof window !== 'undefined' && window.location && window.location.search) {
      const params = new URLSearchParams(window.location.search);
      const fbclid = params.get('fbclid');
      if (fbclid) fbc = `fb.1.${Date.now()}.${fbclid}`;
    }
  } catch (e) {
    /* ignore */
  }
  return { fbp: read('_fbp'), fbc };
};
